import { useState, useEffect } from "react";
import { GitCompare } from "lucide-react";
import api from "../api";
import { useAppContext } from "../context/AppContext";

export default function CompareButton({ propertyId, style = {} }) {
  const { user, lang, setToast } = useAppContext();
  const [isCompared, setIsCompared] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user) return;
    api.get(`/api/comparisons/check/${propertyId}`)
      .then(r => setIsCompared(r.isCompared))
      .catch(() => {});
  }, [propertyId, user]);

  const toggleComparison = async (e) => {
    e.stopPropagation();
    if (!user) {
      setToast({ msg: lang === "en" ? "Please log in to compare properties" : "يرجى تسجيل الدخول للمقارنة", type: "info" });
      return;
    }

    setLoading(true);
    try {
      if (isCompared) {
        await api.delete(`/api/comparisons/${propertyId}`);
        setIsCompared(false);
      } else {
        const existing = await api.get("/api/comparisons");
        if (existing.length >= 2) {
          setToast({
            msg: lang === "en"
              ? "You can compare up to 2 properties. Remove one first."
              : "يمكنك مقارنة عقارين فقط. احذف أحدهما أولاً.",
            type: "info",
          });
          return;
        }
        await api.post("/api/comparisons", { projectId: propertyId });
        setIsCompared(true);
        setToast({
          msg: lang === "en" ? "Added to comparison" : "تمت الإضافة للمقارنة",
          type: "success",
        });
      }
    } catch {
      setToast({ msg: lang === "en" ? "Failed to update comparison." : "فشل تحديث المقارنة.", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={toggleComparison}
      disabled={loading}
      title={lang === "en" ? (isCompared ? "Remove from compare" : "Add to compare") : (isCompared ? "إزالة من المقارنة" : "إضافة للمقارنة")}
      style={{
        position: "absolute",
        top: 12,
        left: 12,
        width: 36,
        height: 36,
        borderRadius: "50%",
        background: isCompared ? "rgba(37,99,235,.92)" : "rgba(255,255,255,0.92)",
        border: isCompared ? "2px solid #2563eb" : "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: loading ? "not-allowed" : "pointer",
        transition: "all 0.25s",
        boxShadow: "0 2px 8px rgba(0,0,0,.18)",
        ...style,
      }}
      onMouseEnter={(e) => { if (!loading) e.currentTarget.style.transform = "scale(1.12)"; }}
      onMouseLeave={(e) => { e.currentTarget.style.transform = "scale(1)"; }}
    >
      <GitCompare
        size={16}
        stroke={isCompared ? "#fff" : "#444"}
        style={{ transition: "all 0.25s" }}
      />
    </button>
  );
}
